var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgCurators = function SvgCurators(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "curators_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#curators_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.554 3.467a3.473 3.473 0 0 1 3.299 2.402.612.612 0 0 0-.537.24.493.493 0 0 0-.017.558.578.578 0 0 0 .428.262.653.653 0 0 0 .081.005c.554 0 1.022-.457.892-.995a4.272 4.272 0 0 0-4.146-3.272 4.272 4.272 0 0 0-4.147 3.272c-.13.538.339.995.893.995a.653.653 0 0 0 .207-.034.578.578 0 0 0 .302-.233.493.493 0 0 0-.017-.558.612.612 0 0 0-.537-.24 3.473 3.473 0 0 1 3.299-2.402ZM7.687 6.4a2.133 2.133 0 1 1-4.266 0 2.133 2.133 0 0 1 4.266 0ZM1.405 11.71c-.123.369.1.746.459.898 1.083.462 2.344.727 3.69.727s2.607-.265 3.69-.727c.358-.152.582-.529.46-.898-.455-1.363-2.14-2.375-4.15-2.375-2.01 0-3.695 1.012-4.15 2.375Zm9.128.291c0 .222-.032.438-.094.648.192.013.386.019.582.019 1.147 0 2.223-.22 3.155-.605.36-.148.585-.528.448-.892-.433-1.155-1.882-2.003-3.603-2.003-.745 0-1.438.159-2.02.432.945.606 1.532 1.458 1.532 2.401Zm-.727-3.982A3.398 3.398 0 0 0 10.487 6c0-.388-.07-.763-.198-1.118a1.867 1.867 0 1 1-.484 3.135Zm.161-3.796a3.956 3.956 0 0 0-.438-.577c.456-.2.961-.311 1.491-.311a3.738 3.738 0 0 1 3.627 2.856c.116.474-.29.877-.779.877a.57.57 0 0 1-.181-.03.506.506 0 0 1-.264-.203.431.431 0 0 1 .014-.489.536.536 0 0 1 .47-.21 3.039 3.039 0 0 0-3.94-1.913Z",
    fill: "currentColor"
  }))));
};
export default SvgCurators;